import React, { useState } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import { DatePickerInput } from "rc-datepicker";
import { FormGroup } from "react-bootstrap";

const SiteInvoiceFilterForm = ({
  applyFilter,
  siteTypes = [],
  assignedAreas = [],
  reportees = [],
  siteStatus = [],
  requestFilter=false,
  ageFilter=false
}) => {
  const filterInputs = {
    site_no: '',
    client_name: '',
    site_type: '',
    area_id: '',
    reportee: '',
    action_status: '',
    request_type:'',
    invoice_no: '',
    fromDate: "",
    toDate: "",
    status_id:"",
    invoice_age:"",
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [isFocus2, setIsFous2] = useState(false);
  const [isFocus3, setIsFous3] = useState(false);

  const handleDateChange2 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      fromDate: dateString,
    });
  };
  const handleDateChange3 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      toDate: dateString,
    });
  };
  const handleDateHide2 = () => {
    if (!filterFieldsData.fromDate) {
      setIsFous2(true);
    }
  };
  const handleDateHide3 = () => {
    if (!filterFieldsData.toDate) {
      setIsFous3(true);
    }
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label={localization.clientName}
        value={filterFieldsData.client_name}
        regex={Regex.text.test(filterFieldsData.client_name)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, client_name: val })
        }
      />
       <ConstantInput
        label={localization.invoiceNo}
        value={filterFieldsData.invoice_no}
        regex={Regex.number.test(filterFieldsData.invoice_no)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, invoice_no: val })
        }
      />
      {requestFilter === false && 
        <ConstantInput
        label={localization.siteNumber}
        value={filterFieldsData.site_no}
        regex={Regex.number.test(filterFieldsData.site_no)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_no: val })
        }
      />
      }
      {requestFilter === true &&
      <>
        <DropDownInput
                  label="Select Status"
                  data={[
                    {
                      id: "PENDING",
                      name: "PENDING",
                    },
                    {
                      id: "HOLD",
                      name: "HOLD",
                    },
                    {
                      id: "APPROVED",
                      name: "APPROVED",
                    },
                    {
                      id: "REJECT",
                      name: "REJECT",
                    },
                  ]}
                  value={filterFieldsData.action_status}
                  getIdValue={(val) => {
                    setFilterFieldsData({
                      ...filterFieldsData,
                      action_status: val.id,
                    });
                    // handledropDownChange(val, i, "action_status");
                  }}
                 
                />

                <DropDownInput
                  label="Select Request Type"
                  data={[
                    {
                      id: "ADVANCE",
                      name: "ADVANCE",
                    },
                    {
                      id: "ADJUSTMENT",
                      name: "ADJUSTMENT",
                    },
                    {
                      id: "PAYMENT",
                      name: "PAYMENT",
                    },
                   
                  ]}
                  value={filterFieldsData.request_type}
                  getIdValue={(val) => {
                    setFilterFieldsData({
                      ...filterFieldsData,
                      request_type: val.id,
                    });
                    // handledropDownChange(val, i, "action_status");
                  }}
                 
                />


          <fieldset>
                  <h4>{localization.createdBetween}</h4>

                  <FormGroup
                    className={`date custom_date_picker ${isFocus2 ? "active-date" : ""}`}
                  >
                    <DatePickerInput
                      onChange={handleDateChange2}
                      value={filterFieldsData.fromDate}
                      autoClose
                      onShow={() => setIsFous2(true)}
                      onHide={handleDateHide2}
                      closeOnClickOutside
                      showOnInputClick
                      locale="en"
                      className="my-custom-datepicker-component"
                      displayFormat="DD-MM-YYYY"
                      returnFormat="DD-MM-YYYY"
                      maxDate={new Date()}
                    />
                    <label>{localization.fromDate}</label>
                  </FormGroup>

                  <FormGroup
                    className={`date custom_date_picker ${isFocus3 ? "active-date" : ""}`}
                  >
                    <DatePickerInput
                      onChange={handleDateChange3}
                      value={filterFieldsData.toDate}
                      autoClose
                      onShow={() => setIsFous3(true)}
                      onHide={handleDateHide3}
                      closeOnClickOutside
                      showOnInputClick
                      locale="en"
                      className="my-custom-datepicker-component"
                      displayFormat="DD-MM-YYYY"
                      returnFormat="DD-MM-YYYY"
                      maxDate={new Date()}
                    />

                    <label>{localization.toDate}</label>
                  </FormGroup>
                </fieldset>
                

                </>
      }
      
      
    {siteTypes.length !== 0 ? 
    
    <DropDownInput
        disabled={siteTypes.length === 0}
        label={localization.siteType}
        data={siteTypes}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_type: val.id })
        }
      />
    : ''}
    {ageFilter === true && 
        <ConstantInput
        label={localization.invoiceAge}
        value={filterFieldsData.invoice_age}
        type="number"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, invoice_age: val })
        }
      />
      }
      {siteStatus === 1 ? 
      <DropDownInput
      disabled={siteStatus.length === 0}
      label={`Invoice Status`}
      data={[
        {
          id: "PENDING",
          name: "PENDING",
        },
        {
          id: "IN_PROGRESS",
          name: "IN_PROGRESS",
        },
        {
          id: "PARTIALLY_RECEIVED",
          name: "PARTIALLY_RECEIVED",
        },
        {
          id: "RECEIVED",
          name: "RECEIVED",
        },
        {
          id: "CANCELLED",
          name: "CANCELLED",
        },
        {
          id: "CONVERTED",
          name: "CONVERTED",
        },
        {
          id: "SALE_RETURN",
          name: "SALE_RETURN",
        },
      ]}
      getIdValue={(val) =>
        setFilterFieldsData({ ...filterFieldsData, status_id: val.id })
      }
    />
      : ''}
      
      {assignedAreas.length !== 0 ? 
      <DropDownInput
      disabled={assignedAreas.length === 0}
      label={localization.assignedArea}
      data={assignedAreas}
      getIdValue={(val) =>
        setFilterFieldsData({ ...filterFieldsData, area_id: val.id })
      }
    />
      : ''}
      {reportees.length !== 0 ? <DropDownInput
        disabled={reportees.length === 0}
        label={localization.reportee}
        data={reportees}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, reportee: val.id })
        }
      /> : ''}
      
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default SiteInvoiceFilterForm;
